export default __webpack_public_path__ + "static/Detox_Smoothie-2d520019d1035ad97230aa4322d9b965.jpg";